import React, {useEffect, useState, useMemo} from 'react';
import {Button, Checkbox, Input, Space, Table, Tag, Typography} from "antd";
import s from './styles/profile.module.css'
import AddObject from "./AddObject";
import axios from 'axios'
import style from "./styles/profile.module.css";
import {
    CheckSquareOutlined,
    DoubleRightOutlined,
    EditOutlined,
    SortAscendingOutlined,
    SortDescendingOutlined
} from "@ant-design/icons";
import moment from "moment/moment";
import Search from "antd/es/input/Search";
import {instance} from "../../API/API";

const { Text } = Typography;

const renderLastServiceDate = (timestamp) => {
    if (!timestamp) {
        return <Text type="secondary">Нет данных</Text>;
    }

    const date = moment(Number(timestamp) * 1000);
    if (!date.isValid()) {
        return <Text type="secondary">Нет данных</Text>;
    }

    const now = moment();
    const daysPassed = now.diff(date, 'days');

    let color = 'green';
    if (daysPassed >= 7 && daysPassed <= 30) {
        color = 'gold';
    } else if (daysPassed > 30) {
        color = 'red';
    }

    return (
        <div>
            <Text>{date.format('DD.MM.yy HH:mm (dddd)')}</Text>
            {daysPassed >= 0 && (
                <div>
                    <Tag color={color}>
                        {daysPassed === 0
                            ? 'Менее 1 дн. с последнего обслуживания'
                            : `${daysPassed} дн. с последнего обслуживания`}
                    </Tag>
                </div>
            )}
        </div>
    );
};

export const NewObjectsList = (props) => {
    const [isNew, setIsNew] = useState(false);
    const [showArchives, setShowArchives] = useState(false);
    const [showActual, setShowActual] = useState(true);
    const [showTimes, setShowTimes] = useState(false);
    const [objects, setObjects] = useState([]);
    const [load, setLoad] = useState(false);
    const [searchName, setSearchName] = useState("");
    const [sortStatus, setSortStatus] = useState(1); // 0 - по умолчанию, 1 - А-Я, 2 - Я-А, 3 - по дате обслуживания

    const get_cookie = (cookie_name) => {
        let results = document.cookie.match('(^|;) ?' + cookie_name + '=([^;]*)(;|$)');
        return results ? unescape(results[2]) : null;
    };

    const getObjectData = async () => {
        setLoad(true);
        try {
            const objects_req = await instance.get(`objects/getObjects.php?avalible=${showArchives ? 1 : 0}&showTimes=${showTimes ? 1 : 0}&showActual=${showActual ? 1 : 0}&api-key=` + get_cookie("hash"));
            if (objects_req) {
                const newObjects = objects_req.data.objects.map((el, index) => {
                    return {
                        ...el,
                        key: index + 1,
                        date_last_service: el.date_last_service ? el.date_last_service : 'н/д',
                        add: {id: el.id, text: '+'},
                        // Добавляем вычисляемое поле для сортировки по дням
                        days_since_last_service: el.date_last_service
                            ? moment().diff(moment(Number(el.date_last_service) * 1000), 'days')
                            : Infinity
                    };
                });
                setObjects(newObjects);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoad(false);
        }
    };

    // Функция для сортировки данных
    const sortObjects = (data, sortType) => {
        const filteredData = data.filter(obj =>
            obj.name.toLowerCase().includes(searchName.toLowerCase()) ||
            obj.long_name.toLowerCase().includes(searchName.toLowerCase())
        );

        switch (sortType) {
            case 1: // А-Я
                return [...filteredData].sort((a, b) =>
                    a.name.localeCompare(b.name)
                );
            case 2: // Я-А
                return [...filteredData].sort((a, b) =>
                    b.name.localeCompare(a.name)
                );
            case 3: // по дате обслуживания
                return [...filteredData].sort((a, b) => {
                    const aDays = a.days_since_last_service;
                    const bDays = b.days_since_last_service;
                    return aDays - bDays; // от наименьшего к большему
                });
            default: // по умолчанию (как пришли)
                return filteredData;
        }
    };

    // Используем useMemo для оптимизации сортировки
    const sortedObjects = useMemo(() => {
        return sortObjects(objects, sortStatus);
    }, [objects, sortStatus, searchName]);

    const columns = [
        {
            title: <div style={{display: 'flex'}}>
                <Search
                    className={style.search}
                    placeholder={'Наименование объекта'}
                    value={searchName}
                    onChange={e => setSearchName(e.target.value)}
                />
                <div className={style.sortIcon__cont}>
                    <SortAscendingOutlined
                        style={{color: sortStatus === 1 ? 'green' : '#ccc'}}
                        onClick={() => setSortStatus(sortStatus !== 1 ? 1 : 0)}
                    />
                    <SortDescendingOutlined
                        style={{color: sortStatus === 2 ? 'green' : '#ccc'}}
                        onClick={() => setSortStatus(sortStatus !== 2 ? 2 : 0)}
                    />
                    {/* Добавляем иконку для сортировки по дате обслуживания */}
                    <CheckSquareOutlined
                        style={{color: sortStatus === 3 ? 'green' : '#ccc', marginLeft: 8}}
                        onClick={() => setSortStatus(sortStatus !== 3 ? 3 : 0)}
                        title="Сортировка по дате обслуживания"
                    />
                </div>
            </div>,
            dataIndex: 'name',
            key: 'name',
            render: (text, obj) => (
                <div className={style.obj_name__cont}>
                    <div className={style.obj_name__text}>{text}</div>
                    <span className={style.obj_name__secondtext}>{obj.long_name}</span>
                </div>
            )
        },
        {
            title: 'Контактное лицо',
            dataIndex: 'contact_name',
            key: 'contact_name',
            width: '150px',
            render: (text, obj) => (
                <div className={style.obj_name__cont}>
                    <div className={style.obj_name__text__2}>{text}</div>
                    <span className={style.obj_name__secondtext}>{obj.contacts}</span>
                </div>
            )
        },
        {
            title: 'Автополив',
            dataIndex: 'auto_water',
            key: 'auto_water',
            render: text => Number(text) === 1 ? <CheckSquareOutlined style={{color: 'green', fontSize: 18}}/> : '',
            width: '80px',
            align: 'center'
        },
        {
            title: 'Последнее посещение',
            dataIndex: 'date_last_service',
            key: 'date_last_service',
            width: '250px',
            align: 'left',
            render: (timestamp) => renderLastServiceDate(timestamp),
        },
        {
            dataIndex: 'add',
            key: 'add',
            render: text => <DoubleRightOutlined onClick={() => { props.exp(text.id) }}/>,
            width: '50px',
            align: 'center'
        },
        {
            key: 'id',
            align: 'center',
            width: '50px',
            render: id => (
                <Space size="middle">
                    <a onClick={() => { props.edit(id) }}><EditOutlined /></a>
                </Space>
            ),
        },
    ];

    useEffect(() => {
        getObjectData();
    }, [showArchives, showTimes, showActual]);

    return isNew ? (
        <AddObject
            close={() => setIsNew(false)}
            post={props.post}
            districts={props.districts}
            current={props.current}
            editing={props.editing}
        />
    ) : (
        <div style={{width: '100%', margin: '0 auto', boxSizing: 'border-box', padding: '0', overflowX: 'hidden'}}>
            <div className={s.addObjBtn__cont}>
                <Button type="primary" onClick={() => setIsNew(true)}>
                    Добавить объект
                </Button>
                <Checkbox
                    style={{margin: '0 5px 0 20px', width: '100px'}}
                    onChange={(e) => setShowActual(e.target.checked)}
                    checked={showActual}
                >
                    Актуальные
                </Checkbox>
                <Checkbox
                    style={{margin: '0 5px 0 20px', width: '100px'}}
                    onChange={(e) => setShowArchives(e.target.checked)}
                    checked={showArchives}
                >
                    Архивные
                </Checkbox>
                <Checkbox
                    style={{margin: '0 5px'}}
                    onChange={(e) => setShowTimes(e.target.checked)}
                    checked={showTimes}
                >
                    Временные
                </Checkbox>
            </div>
            <div className={s.listTable}>
                <Table
                    loading={load}
                    size={'small'}
                    bordered={true}
                    pagination={false}
                    columns={columns}
                    dataSource={sortedObjects} // Используем отсортированные данные
                    onChange={props.onChange}
                    className="my-table"
                    rowClassName={() => ''}
                />
            </div>
        </div>
    );
};